import { useState, useEffect } from "react";
import "./Auth.css";

function RegistroPassword() {
  const [password, setPassword] = useState("");
  const [confirmar, setConfirmar] = useState("");
  const [show, setShow] = useState(false);
  const [token, setToken] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    setToken(params.get("token"));
  }, []);

  const guardarPassword = async () => {
    if (password !== confirmar) {
      alert("Las contraseñas no coinciden");
      return;
    }

    if (password.length < 6) {
      alert("La contraseña debe tener mínimo 6 caracteres");
      return;
    }

    const res = await fetch(
      "https://sindicato.sintrasecsalud.com/api/index.php?modulo=auth&accion=crearPassword",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      },
    );

    const data = await res.json();

    if (data.success) {
      alert("Contraseña creada correctamente");
      window.location.href = "/";
    } else {
      alert(data.message);
    }
  };

  return (
    <div className="auth-wrapper">
      <div className="auth-card">
        <h4>Crear tu contraseña</h4>

        <div className="password-group mb-3">
          <input
            type={show ? "text" : "password"}
            className="form-control auth-input"
            placeholder="Nueva contraseña"
            onChange={(e) => setPassword(e.target.value)}
          />
          <span className="password-toggle" onClick={() => setShow(!show)}>
            👁️
          </span>
        </div>

        <input
          type="password"
          className="form-control auth-input mb-3"
          placeholder="Confirmar contraseña"
          onChange={(e) => setConfirmar(e.target.value)}
        />

        <button className="auth-btn" onClick={guardarPassword}>
          Guardar contraseña
        </button>
      </div>
    </div>
  );
}

export default RegistroPassword;
